var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrizeGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 46,
    viewBox: "0 0 339 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C133.832 11.9608 208.882 18.7815 338.6 0V46C199.901 19.7437 125.788 19.5437 0 46V0Z",
    fill: "url(#paint0_linear_533_4589)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_533_4589",
    x1: -60.2986,
    y1: -1.8012,
    x2: 200.787,
    y2: 244.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105188,
    stopColor: "#F875DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401176,
    stopColor: "#F1DD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594967,
    stopColor: "#F77A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746947,
    stopColor: "#F26BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921186,
    stopColor: "#65A7F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeGradient);
export default __webpack_public_path__ + "static/media/prizeGradient.cbf4a564d2139044d630df65b11c4291.svg";
export { ForwardRef as ReactComponent };